import React, { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import PropTypes from "prop-types";

import FormResponse from "components/FormResponse";
import { COLUMN_HEADER_KEYS, ROLE_SP_PROPOSAL_ADMINISTRATOR, ROLE_SP_SYSTEM_ADMINISTRATOR } from "globals/constants";
import { useDictionary, useFormAccesses, useHasRoles, useRecordRevisionAccess } from "hooks";
import { getProposal, getProposalValues } from "store/actions/proposal";
import { proposalSelectors } from 'store/selectors';
import { getStoredFormStatus } from "utils";


const ProposalFormView = props => {
	const proposal = useSelector(proposalSelectors.proposal);
	const { proposalId: loadedId } = useParams();
	const dictionary = useDictionary("common.form", { sectionTitle: "Proposal Sections" });
	const formAccesses = useFormAccesses(COLUMN_HEADER_KEYS.PROPOSAL, loadedId);
	const hasRecordRevisionEditAccess = useRecordRevisionAccess(COLUMN_HEADER_KEYS.PROPOSAL, proposal.statusName, formAccesses);

	const canEdit = useMemo(() => {
		const proposalInDevelopment = proposal.statusName === "In Development";

		return proposalInDevelopment && formAccesses.updateForm;
	}, [ formAccesses.updateForm, proposal.statusName ]);

	const onFormSave = useCallback(() => {
		getProposalValues({
			proposalId: proposal.proposalId,
			fieldKeys: [] // todo: align with whatever Summary needs to fetch
		});
	}, [ proposal.proposalId ]);

	const reloadProposal = useCallback(() => {
		getProposal(proposal.proposalId, { isRefresh: true });
	}, [ proposal.proposalId ]);

	const {
		[ROLE_SP_PROPOSAL_ADMINISTRATOR]: isProposalAdmin,
		[ROLE_SP_SYSTEM_ADMINISTRATOR]: isSystemAdmin
	} = useHasRoles([ ROLE_SP_PROPOSAL_ADMINISTRATOR ]);

	return (
		<FormResponse
			key={loadedId}
			form={proposal}
			canEdit={canEdit}
			dictionary={dictionary}
			formIdKey="proposalId"
			formType={COLUMN_HEADER_KEYS.PROPOSAL}
			isFormAdmin={isProposalAdmin || isSystemAdmin || false}
			loadedFormId={loadedId}
			onFlowableFormSave={onFormSave}
			payloadRootContentKey={"proposalContent"}
			saveOnChange={proposal.statusKey === "in-development"}
			saveValuesApiUrl={`/sp/api/proposals/${proposal.proposalId}`}
			statusId={proposal.statusKey}
			recordRevisionEditMode={hasRecordRevisionEditAccess}
			onReload={reloadProposal}
			{...props}
		/>
	);
};

ProposalFormView.propTypes = {
	handleFormLoaded: PropTypes.func,
	setFormVariables: PropTypes.func,
	formVariables: PropTypes.object,
};

export default ProposalFormView;
